import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

interface StatCardProps {
  label: string;
  value: number;
  icon: React.ReactNode;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, icon }) => {
  return (
    <Card
      elevation={0}
      sx={{
        padding: '0px 60px 0px 0px',
        borderRadius: '6px',
        backgroundColor: '#F6F6F6',
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <Box
            sx={{
              background: '#f0f0f0',
              borderRadius: '50%',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {icon}
          </Box>
          <Box>
            <Typography fontWeight={600} fontSize={20}>
              {value}
            </Typography>
            <Typography fontSize={16} fontWeight={400} color='#9E9E9E'>
              {label}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;
